import Image from "next/legacy/image";
import { Button, Card, Language } from "@chef/components";
import { intl } from "./AbandonBasketWarning.Intl";

interface WeekEditorExitWarningV2Props {
  onCancel: () => void;
  language?: Language;
  products?: { img?: string; alt?: string }[];
  onButtonClick?: () => void;
  onLeaveWithoutSaving?: () => void;
  minMeals: number;
}

export const AbandonBasketWarning = ({
  onCancel,
  products = [],
  onButtonClick = () => null,
  onLeaveWithoutSaving = () => null,
  minMeals,
}: WeekEditorExitWarningV2Props) => {
  return (
    <Card
      noPadding
      className="relative w-full px-6 py-12 mx-auto overflow-y-auto text-base text-center md:p-20 md:mt-28 lg:max-w-1/2 md:max-w-2xl"
    >
      <div>
        <div className="text-center">
          <ul className="flex mx-auto space-x-1 md:space-x-2 place-content-center ">
            {products?.map((p) => (
              <li className="relative flex-grow max-w-xs bg-grey-3" key={p.alt}>
                <Image
                  src={p.img || ""}
                  alt={p.alt}
                  loader={({ src }) => src}
                  layout="responsive"
                  objectFit="cover"
                  width={2}
                  height={3}
                />
              </li>
            ))}
          </ul>
        </div>
        <h2 className="my-6">
          <strong>{intl.CHANGES_NOT_SAVED}</strong>
        </h2>
        <p className="mt-2 text-base">{intl.CHANGES_NOT_SAVED_DETAILED}</p>
        <div className="mt-8">
          <Button
            onClick={onButtonClick}
            primary
            disabled={products.length < minMeals}
          >
            <div className="w-60 md:w-64">{intl.SAVE}</div>
          </Button>
        </div>
        <div className="mt-4">
          <Button outlined onClick={onLeaveWithoutSaving}>
            <div className="w-60 md:w-64">{intl.LEAVE_WITHOUT_SAVING}</div>
          </Button>
        </div>
        <div className="mt-10 ">
          <button role="link" type="button" onClick={onCancel}>
            <strong className="underline underline-offset-2">
              {intl.CANCEL}
            </strong>
          </button>
        </div>
      </div>
    </Card>
  );
};
